<!-- Content/Media Uploader -->
@if (showUploader()) {
    <div class="overlay">
        <ntv-uploader
            #uploader
            [showProviders]="false"
            [isCheckingDuplicates]="isCheckingDuplicates()"
            [uploadConfig]="uploadConfig() ?? defaultUploadConfig"
            [maxFiles]="maxFilesToUpload()"
            [duplicateResults]="duplicateFiles()"
            [existingLibraryNames]="existingLibraryNames()"
            (filesSelected)="onFilesSelected($event)"
            (fileRenamed)="onFileRenamed($event)"
            (uploadConfirmed)="onUploadFiles($event)"
            (uploadCancelled)="onCancelUpload()"
            (close)="onUploaderClose()" />
    </div>
}
